export default parseInt;
//# sourceMappingURL=to-integer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/to-integer.js
// module id = 528
// module chunks = 3